/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import { forIn } from "lodash";
/**
 * decode HTML
 * @param {html} html html value.
 * @returns {string} Return string value.
 */
function decodeHTML(html) {
    var decodedObject = html;
    if (typeof decodedObject === "string") {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        decodedObject = JSON.parse(txt.value);
    }
    return decodedObject;
}

Vue.use(Vuex);

const getInitialQuestion = window.GuidedProductFinderAPIRoutes.start + "?quizid=";
const getQuestion = window.GuidedProductFinderAPIRoutes.getquestion + "?qid=";
const getNextQuestion = window.GuidedProductFinderAPIRoutes.submitquestion;
const getAssetBody = window.GuidedProductFinderAPIRoutes.getassetbody + "?";
const getAsset = window.GuidedProductFinderAPIRoutes.getasset + "?";

/**
 * Global Constants for defining API endpoints
 *
 */

export function getVuexStore() {
    return new Vuex.Store({
        state: {
            jsonLoading: true,
            smallLoading: false,
            errorShow: false,
            errorMessage: "Something went wrong!",
            externalUrl: "",
            category: "",
            quickview: "",
            quizData: null,
            questionData: null,
            stepData: null,
            visibleAnswers: {},
            showLandingPage: false,
            showEndPage: false,
            showPrivatePage: false,
            nextDisabled: true,
            welcomeHTML: "",
            endHTML: "",
            privateHTML: "",
            showProductsJSON: "",
            showProductsPage: false,
            showRecomms: false,
            showRecommendations: false,
            showproductscarousel: [],
            isSFRA: false,
            showQuiz: true,
            isAnswerMax: false,
            isHidden: true,
            contentAsset: "",
        },
        mutations: {
            setWelcomeHTML(state, data) {
                state.welcomeHTML = data;
            },
            setEndHTML(state, data) {
                state.endHTML = data;
            },
            setShowProductsJSON(state, data) {
                state.showProductsJSON = data;
            },
            setPrivateHTML(state, data) {
                state.privateHTML = data;
            },
            setJSONLoading(state, loading) {
                state.jsonLoading = loading;
            },
            setSmallLoading(state, loading) {
                state.smallLoading = loading;
            },
            setErrorShow(state) {
                state.errorShow = true;
            },
            setErrorMessage(state, error) {
                state.errorMessage = error;
            },
            setExternalUrl(state, url) {
                state.externalUrl = url;
            },
            setCategory(state, url) {
                state.category = url;
            },
            setQuickView(state, url) {
                state.quickview = url;
            },
            setShowProductsCarousel(state, data) {
                state.showproductscarousel = data;
            },
            setShowRecommendations(state, show) {
                state.showRecommendations = show;
            },
            setProductRecommendationsMessage(state, show) {
                state.productRecommendationsMessage = show;
            },
            setQuiz(state, data) {
                state.quizData = data;
                state.errorMessage = data.translations.generalError;
            },
            setAnswerValue(state, data) {
                var answers = state.questionData.answers;
                answers[0].value = data[1];
            },
            setQuestion(state, data) {
                /**
                 * Set selected and disabled states on received data
                 * based on previous answers, in order to display
                 * question with answers filled in
                 */
                const isAlreadyAnswered = data.questionData.userAnswer.length > 0 && data.questionData.userAnswer[0] !== "";
                forIn(data.questionData.answers, function (answer) {
                    answer.selected = isAlreadyAnswered ? false : answer.isDefaultAnswer || false;
                    answer.disabled = false;
                    answer.hovered = false;
                });

                state.nextDisabled = true;
                var visibleAnswers = state.visibleAnswers[data.questionData.id];

                // There can be no list of visible answers for the question
                if (visibleAnswers) {
                    // If the list of visible answers exists, select only them from
                    // the whole list of answers
                    var filteredAnswers = data.questionData.answers.filter((answer) =>
                        visibleAnswers.includes(answer.id)
                    );

                    data.questionData.answers = filteredAnswers;
                }

                if (isAlreadyAnswered) {
                    var answers = data.questionData.answers;
                    var answerDisabled = data.questionData.showAnswersAsDisabled;
                    var answersMax = data.questionData.maxAnswers;
                    var userAnswers = data.questionData.userAnswer;

                    forIn(userAnswers, function (userAnswer) {
                        var matchIndex = answers.map((ans) => ans.id).indexOf(userAnswer);
                        if (matchIndex >= 0) {
                            data.questionData.answers[matchIndex].selected = true;
                            state.nextDisabled = false;
                        }
                    });

                    if (userAnswers.length == answersMax) {
                        forIn(data.questionData.answers, function (answer, index) {
                            if (answerDisabled && !answer.selected) {
                                data.questionData.answers[index].disabled = true;
                            }
                        });
                    }
                }

                state.questionData = data.questionData;
                state.stepData = data.stepData;
            },
            setVisibleAnswers(state, data) {
                state.visibleAnswers[data.questionID] = data.answers;
            },
            setWelcome(state, show) {
                state.showLandingPage = show;
            },
            setEnd(state, show) {
                state.showEndPage = show;
            },
            setPrivate(state, show) {
                state.showPrivatePage = show;
            },
            setShowProducts(state, show) {
                state.showProductsPage = show;
            },
            setNextButtonState(state, status) {
                state.nextDisabled = status;
            },
            setHover(state, d) {
                var answers = state.questionData.answers;
                var hoveredAnswer = answers[answers.map((ans) => ans.id).indexOf(d[0].aid)];

                forIn(answers, function (answer) {
                    answer.hovered = false;
                });

                hoveredAnswer.hovered = d[0].hover;
            },
            setAnswer(state, aid) {
                var answers = state.questionData.answers;
                var answerType = state.questionData.type;
                var answerDisabled = state.questionData.showAnswersAsDisabled;
                var answersMin = state.questionData.minAnswers;
                var answersMax = state.questionData.maxAnswers;
                var answerIndex = answers.map((ans) => ans.id).indexOf(aid);
                var currentAnswer = answers[answerIndex];

                // if single
                if (answerType === "single") {
                    if (!currentAnswer.selected) {
                        forIn(answers, function (answer) {
                            answer.selected = false;
                        });
                        currentAnswer.selected = true;

                        state.nextDisabled = false;
                    }
                }
                // if multiple
                if (answerType === "multiple") {
                    // Read initial number of selected answers
                    var selectedAnswers = 0;
                    forIn(answers, function (answer) {
                        if (answer.selected == true) {
                            selectedAnswers += 1;
                        }
                    });

                    if (!currentAnswer.selected && selectedAnswers < answersMax) {
                        currentAnswer.selected = true;
                    } else if (currentAnswer.selected) {
                        currentAnswer.selected = false;
                    }

                    // Read number of selected answers after current selection
                    selectedAnswers = 0;

                    forIn(answers, function (answer) {
                        if (answer.selected == true) {
                            selectedAnswers += 1;
                        }
                    });

                    // If selected answers countf it in between min and max we allow submission
                    if (selectedAnswers >= answersMin && selectedAnswers <= answersMax) {
                        state.nextDisabled = false;
                    } else {
                        state.nextDisabled = true;
                    }

                    // When we need the max selected answers
                    if (selectedAnswers === answersMax && state.quizData.accordionGoToNextQuestion === true) {
                        state.isAnswerMax = true;
                    } else {
                        state.isAnswerMax = false;
                    }

                    // Determining showdisabled state
                    if (selectedAnswers == answersMax && answerDisabled) {
                        forIn(answers, function (answer) {
                            if (!answer.selected) {
                                answer.disabled = true;
                            }
                        });
                    } else {
                        forIn(answers, function (answer) {
                            if (!answer.selected) {
                                answer.disabled = false;
                            }
                        });
                    }
                }
            },
            setShowQuiz(state, show) {
                state.showQuiz = show;
            },
            setContentAssetHTML(state, data) {
                state.contentAsset = data;
            },
            setStepData(state, data) {
                state.stepData = data;
            },
        },
        actions: {
            // Mehtod that populates the store on initial load
            loadInitialQuestion(context, { qid, reset }) {
                var url = "";

                if (reset) {
                    url = getInitialQuestion + qid + "&reset=true";
                    context.commit("setJSONLoading", true);
                } else {
                    url = getInitialQuestion + qid;
                }

                context.commit("setShowRecommendations", false);

                axios
                    .get(url)
                    .then((response) => {
                        response.data = decodeHTML(response.data);
                        // check for invalid license
                        if (response.data.invalidlicense == true) {
                            context.commit("setJSONLoading", false);
                            context.commit("setErrorMessage", response.data.invalidlicenseText);
                            context.commit("setErrorShow", true);
                        }
                        // check to see if the quiz is private
                        if (response.data.private == true) {
                            var http = new XMLHttpRequest();
                            var url = getAssetBody;
                            var params = "assetID=" + response.data.asset;
                            http.open("POST", url, true);

                            // Send the proper header information along with the request
                            http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

                            http.onreadystatechange = function () {
                                // Call a function when the state changes.
                                if (http.readyState == 4 && http.status == 200) {
                                    context.commit("setPrivateHTML", this.responseText);
                                    context.commit("setPrivate", true);
                                    context.commit("setJSONLoading", false);
                                }
                            };

                            http.send(params);
                        } else if (response.data.quizData.quizVisibleForCustomer === false) {
                            context.commit("setJSONLoading", false);
                            context.commit("setShowQuiz", false);
                        } else if (response.data.quizData.quizVisibleForCustomer === true) {
                            const res = response.data;
                            const qData = res.quizData;
                            const stepData = res.stepData;

                            context.commit("setQuiz", qData);
                            context.commit("setQuestion", res);
                            if (res.questionData.renderTemplate === "Template9") {
                                var contentAsset = res.questionData.modalContent;
                                http = new XMLHttpRequest();
                                url = getAssetBody;
                                params = "assetID=" + contentAsset;
                                http.open("POST", url, true);

                                // Send the proper header information along with the request
                                http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

                                http.onreadystatechange = function () {
                                    // Call a function when the state changes.
                                    if (http.readyState == 4 && http.status == 200) {
                                        context.commit("setContentAssetHTML", this.responseText);
                                    }
                                };
                                http.send(params);
                            }

                            /**
                             *
                             * Determining if we are comming back to the quiz,
                             * and we need to redirect user to the step next to
                             * the last answered question, else we start
                             * from the beggining
                             */
                            if (res.quizData.lastAnsweredQuestionID !== "" && qData.type === "directional") {
                                var nextStepIndex =
                                    stepData.titles.map((item) => item.id).indexOf(qData.lastAnsweredQuestionID) + 1;
                                var stepLength = stepData.total - 1;

                                if (nextStepIndex > stepLength) {
                                    nextStepIndex = stepLength;
                                }

                                axios
                                    .get(getQuestion + stepData.titles[nextStepIndex].id)
                                    .then((resp) => {
                                        resp.data = decodeHTML(resp.data);
                                        context.commit("setQuestion", resp.data);
                                        context
                                            .dispatch("preloadImages", {
                                                quizImages: null,
                                                questionImage: response.data.questionData.image,
                                                answersImages: response.data.questionData.answers,
                                            })
                                            .then(() => {
                                                context.commit("setJSONLoading", false);
                                            });
                                    })
                                    .catch(() => {
                                        context.commit("setJSONLoading", false);
                                        context.commit("setErrorShow", true);
                                    });
                            } else {
                                if (qData.showLandingPage && qData.showLandingPage.trim() !== "") {
                                    context.commit("setWelcome", true);
                                    http = new XMLHttpRequest();
                                    url = getAsset;
                                    params = "assetID=" + qData.showLandingPage;
                                    http.open("POST", url, true);

                                    // Send the proper header information along with the request
                                    http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

                                    http.onreadystatechange = function () {
                                        // Call a function when the state changes.
                                        if (http.readyState == 4 && http.status == 200) {
                                            const data = decodeHTML(this.response);
                                            context.commit("setWelcomeHTML", data);
                                            if (res.questionData.renderTemplate === "Template9") {
                                                var contentAsset = res.questionData.modalContent;
                                                http = new XMLHttpRequest();
                                                url = getAssetBody;
                                                params = "assetID=" + contentAsset;
                                                http.open("POST", url, true);

                                                // Send the proper header information along with the request
                                                http.setRequestHeader(
                                                    "Content-type",
                                                    "application/x-www-form-urlencoded"
                                                );

                                                http.onreadystatechange = function () {
                                                    // Call a function when the state changes.
                                                    if (http.readyState == 4 && http.status == 200) {
                                                        context.commit("setContentAssetHTML", this.responseText);
                                                    }
                                                };
                                                http.send(params);
                                            }
                                        }
                                    };
                                    http.send(params);
                                }

                                context
                                    .dispatch("preloadImages", {
                                        quizImages: res.quizData.images,
                                        questionImage: res.questionData.image,
                                        answersImages: res.questionData.answers,
                                    })
                                    .then(() => {
                                        context.commit("setJSONLoading", false);
                                    });
                            }
                        }
                    })
                    .catch(() => {
                        context.commit("setJSONLoading", false);
                        context.commit("setErrorShow", true);
                    });
            },

            preloadImages(context, { quizImages, questionImage, answersImages }) {
                return new Promise((resolve) => {
                    var imagesToPreload = [];

                    if (quizImages) {
                        forIn(quizImages, function (image) {
                            if (image != "") {
                                imagesToPreload.push(image);
                            }
                        });
                    }

                    if (questionImage && questionImage != "") {
                        imagesToPreload.push(questionImage);
                    }

                    if (answersImages.length > 0) {
                        forIn(answersImages, function (answer) {
                            if (answer.image != "") {
                                imagesToPreload.push(answer.image);
                            }
                        });
                    }

                    let imagesLength = imagesToPreload.length;
                    var imagesLoaded = 0;

                    if (imagesLength > 0) {
                        forIn(imagesToPreload, function (image) {
                            var img = new Image();
                            img.src = image;
                            img.onload = function () {
                                imagesLoaded += 1;
                                if (imagesLoaded === imagesLength) {
                                    resolve();
                                }
                            };
                            // if image error (wrong url, missing image etc) still increase the counter
                            img.onerror = function () {
                                imagesLoaded += 1;
                                if (imagesLoaded === imagesLength) {
                                    resolve();
                                }
                            };
                        });
                    } else {
                        resolve();
                    }
                });
            },

            // Mehtod used to get a "direct" question ID data
            gotoQuestion(context, qid) {
                context.commit("setSmallLoading", true);
                context.commit("setShowRecommendations", false);
                //Added to reset the carousel state when a user is on the last page of the quiz and returns to a previous question
                context.commit("setShowProductsCarousel", []);
                axios
                    .get(getQuestion + qid)
                    .then((response) => {
                        response.data = decodeHTML(response.data);
                        context.commit("setQuestion", response.data);
                        context
                            .dispatch("preloadImages", {
                                quizImages: null,
                                questionImage: response.data.questionData.image,
                                answersImages: response.data.questionData.answers,
                            })
                            .then(() => {
                                context.commit("setSmallLoading", false);
                            });
                    })
                    .catch(() => {
                        context.commit("setSmallLoading", false);
                        context.commit("setErrorShow", true);
                    });
            },

            // Mehtod used to get previous question ID data in relation with current question
            prevQuestion(context, qid) {
                context.commit("setSmallLoading", true);

                axios
                    .get(getQuestion + qid)
                    .then((response) => {
                        response.data = decodeHTML(response.data);
                        context.commit("setQuestion", response.data);
                        context
                            .dispatch("preloadImages", {
                                quizImages: null,
                                questionImage: response.data.questionData.image,
                                answersImages: response.data.questionData.answers,
                            })
                            .then(() => {
                                context.commit("setSmallLoading", false);
                            });
                    })
                    .catch(() => {
                        context.commit("setSmallLoading", false);
                        context.commit("setErrorShow", true);
                    });
            },

            // Mehtod used to submit current question answers selection
            submitQuestion(context, data) {
                context.commit("setSmallLoading", true);
                var http;
                var url;
                var params;
                var isSFRA =
                    document.getElementById("guided-product-site") &&
                    document.getElementById("guided-product-site").dataset.isSfra;
                data.isSFRA = isSFRA;
                axios
                    .post(getNextQuestion, data)
                    .then((response) => {
                        response.data = decodeHTML(response.data);
                        let res = response.data;
                        var template;
                        if (res.action != null && res.action === "end") {
                            // set a default template
                            template = "osfquizend";

                            if (res.actionData && res.actionData != "") {
                                template = res.actionData;
                            }

                            http = new XMLHttpRequest();
                            url = getAssetBody;
                            params = "assetID=" + template;
                            http.open("POST", url, true);

                            // Send the proper header information along with the request
                            http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

                            http.onreadystatechange = function () {
                                // Call a function when the state changes.
                                if (http.readyState == 4 && http.status == 200) {
                                    context.commit("setEndHTML", this.responseText);
                                    context.commit("setEnd", true);
                                    context.commit("setSmallLoading", false);
                                }
                            };
                            http.send(params);
                        } else if (res.action != null && res.action === "showproducts") {
                            if (res.stepData) {
                                context.commit("setStepData", res.stepData);
                            }
                            if (res.productRecommendationsMessage && !res.noProducts) {
                                context.commit("setProductRecommendationsMessage", res.productRecommendationsMessage)
                            } else {
                                context.commit("setProductRecommendationsMessage", null)
                            }
                            if (!res.quizInlineResults) {
                                window.location.assign(res.url);
                            } else if (res.noProducts) {
                                context.commit("setJSONLoading", false);
                                context.commit("setShowRecommendations", true);
                                context.commit("setShowProductsCarousel", []);
                            } else {
                                context.commit("setJSONLoading", false);
                                context.commit("setShowRecommendations", false);
                                context.commit("setShowProductsCarousel", res.actionData);
                            }
                        } else if (res.action != null && res.action === "product" && res.actionData !== "") {
                            if (!res.quizInlineResults) {
                                window.location.assign(res.actionData);
                            } else {
                                context.commit("setJSONLoading", false);
                                context.commit("setQuickView", res.actionData);
                            }
                        } else if (res.action != null && res.action === "category" && res.actionData !== "") {
                            if (!res.quizInlineResults) {
                                window.location.assign(res.actionData);
                            } else if (isSFRA === "true") {
                                axios.get(res.actionData).then(() => {
                                    context.commit("setJSONLoading", false);
                                    context.commit("setCategory", res.actionData);
                                });
                            } else {
                                context.commit("setJSONLoading", false);
                                context.commit("setCategory", res.actionData);
                            }
                        } else if (res.action != null && res.action === "redirect" && res.actionData != "") {
                            window.location.assign(res.actionData);
                        } else if (res.action != null && res.action === "externalurl" && res.actionData != "") {
                            if (!res.quizInlineResults) {
                                window.location.assign(res.actionData);
                            } else {
                                context.commit("setJSONLoading", false);
                                context.commit("setExternalUrl", res.actionData);
                            }
                        } else if (res.action != null && res.action === "submitanswers" && res.actionData != "") {
                            window.location.assign(res.actionData);
                        } else {
                            var questionID = res.questionData.id;

                            // The answers we retrieve for the current question
                            // are considered to be "visible"
                            var answers = res.questionData.answers.map((el) => el.id);

                            // Write answer IDs for the current question.
                            // If the answers already exist for the question,
                            // they are rewritten with newer answers
                            context.commit("setVisibleAnswers", {
                                questionID,
                                answers,
                            });
                            context.commit("setQuestion", res);
                            if (res.questionData.renderTemplate === "Template9") {
                                var contentAsset = res.questionData.modalContent;
                                http = new XMLHttpRequest();
                                url = getAssetBody;
                                params = "assetID=" + contentAsset;
                                http.open("POST", url, true);

                                // Send the proper header information along with the request
                                http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

                                http.onreadystatechange = function () {
                                    // Call a function when the state changes.
                                    if (http.readyState == 4 && http.status == 200) {
                                        context.commit("setContentAssetHTML", this.responseText);
                                    }
                                };
                                http.send(params);
                            }
                            context
                                .dispatch("preloadImages", {
                                    quizImages: null,
                                    questionImage: res.questionData.image,
                                    answersImages: res.questionData.answers,
                                })
                                .then(() => {
                                    context.commit("setSmallLoading", false);
                                });
                        }
                    })
                    .catch(() => {
                        context.commit("setSmallLoading", false);
                        context.commit("setErrorShow", true);
                    });
            },
        },
    });
}
